import { render, staticRenderFns } from "./edit-PaymentsAndReceiptses.vue?vue&type=template&id=6e2e3a9c"
import script from "./edit-PaymentsAndReceiptses.vue?vue&type=script&lang=ts"
export * from "./edit-PaymentsAndReceiptses.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports